/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ObservationColumns {
    Association = 'association',
    Panel = 'panel',
    CreatedBy = 'created_by',
    CreatedDate = 'created_date',
    Id = 'id',
    UpdatedBy = 'updated_by',
    ClosedDatePopulatedOn = 'closed_date_populated_on',
    Owner = 'owner_name',
    RootCause = 'root_cause',
    Observation = 'observation',
    Comments = 'comments',
    RecordId = 'record_id',
    Decision = 'decision',
    Review = 'review_title',
    Status = 'status',
    ObservationDate = 'observation_date',
    DateSetOpenedOn = 'dateset_opened_on',
    Reviews = 'reviews',
    OpenActions = 'open_actions',
    RecentAction = 'recent_action',
    UpdatedDate = 'updated_date',
    ClosedDate = 'closed_date',
    Type = 'type',
    SiteName = 'site_name',
    DataListing = 'data_listing',
}

export class SmObservationsGridHelper implements IGridHelper {
    private _customCells: CustomCells;

    constructor(private customCells: CustomCells) {
        this._customCells = customCells;
    }

    disableAdvancedFilter(): boolean {
        return false;
    }

    disableLock(): boolean {
        return false;
    }

    getActiveField(columnType: ColumnDefinition): string | undefined {
        switch (columnType.dataField) {
            case ObservationColumns.Association:
            case ObservationColumns.Panel:
            case ObservationColumns.Owner:
            case ObservationColumns.Decision:
            case ObservationColumns.DataListing: {
                return `${columnType.dataField}_active`;
            }
            default:
                return undefined;
        }
    }

    observationColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ObservationColumns.Status, 110],
        [ObservationColumns.SiteName, 115],
        [ObservationColumns.Review, 200],
        [ObservationColumns.Association, 180],
        [ObservationColumns.Panel, 180],
        [ObservationColumns.DataListing, 180],
        [ObservationColumns.ObservationDate, 145],
        [ObservationColumns.Observation, 400],
        [ObservationColumns.Owner, 200],
        [ObservationColumns.Decision, 190],
        [ObservationColumns.DateSetOpenedOn, 145],
        [ObservationColumns.Reviews, 75],
        [ObservationColumns.OpenActions, 110],
        [ObservationColumns.RecentAction, 120],
        [ObservationColumns.RootCause, 200],
        [ObservationColumns.Comments, 200],
        [ObservationColumns.UpdatedDate, 145],
        [ObservationColumns.ClosedDate, 145],
        [ObservationColumns.ClosedDatePopulatedOn, 145],
        [ObservationColumns.ClosedDate, 145],
        [ObservationColumns.RecordId, 100],
        [ObservationColumns.CreatedBy, 145],
        [ObservationColumns.UpdatedBy, 145],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.observationColumnsWidth.get(columnType.dataField);
    }

    getCustomCell() {
        return undefined;
    }

    getDisplayFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ObservationColumns.CreatedBy:
            case ObservationColumns.CreatedDate:
            case ObservationColumns.Id:
            case ObservationColumns.UpdatedBy:
            case ObservationColumns.ClosedDatePopulatedOn:
            case ObservationColumns.RecordId:
                return false;
            default:
                return true;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition): boolean {
        switch (columnType.dataField) {
            case ObservationColumns.Observation:
            case ObservationColumns.Owner:
            case ObservationColumns.RootCause:
            case ObservationColumns.Comments:
                return true;
            default:
                return false;
        }
    }

    isRagColumn(): boolean {
        return false;
    }

    multiValueFilter(): boolean {
        return false;
    }
}
